import colors from "common/styles/colors";
import { useLayoutEffect } from "react";

export function useGreyBackground() {
  useLayoutEffect(() => {
    document.body.style.backgroundColor = colors.bg;
  });
}
